/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import React, { useState, useEffect } from 'react'
import {
Text,
View,
SafeAreaView,
FlatList} from 'react-native';
import styles from './styles';
import { Firestore, Crashlytics } from '../../firebase/config';
import {ListItem, Switch, Image} from 'react-native-elements';
import {Loader} from '../../components';


export default function NotificationsScreen(props) {
const user = props.extraData.user;
const [loading, setLoading] = useState(true);
const [catalogs, setCatalogs] = useState([]);
const [preferences, setPreferences] = useState(user?.preferences?.notifications || []);
const { navigation } = props;
const productLines = props.extraData.productLines
const catalogsRef = Firestore.collection('Files').doc('Catalogs').collection('Empire Catalogs');
const userRef = Firestore.collection('users').doc(user.id);

function lookupPreference(topic) {
const enabled = preferences?.[topic];
let status = true;
if (enabled === false || !typeof(enabled) === undefined) {
status = false;
}
return status;
}

const setPreference = (topic, value) => {
const path = `preferences.notifications.${topic}`;
const task = userRef.update({
[path]: value
})
//.then(() => {
//toggleSubscription(topic, value);
//})
.catch((e) => {
console.error(`Error updating messaging subscriptions: ${e}`);
Crashlytics.recordError(e);
});
return () => task;
};

/*const toggleSubscription = (topic, status) => {
console.log(`Topic: ${topic} Status: ${status}`)
let task;
switch (status) {
case true:
task = Messaging.subscribeToTopic(topic).then(() => {console.log(`Subscribed To Topic: ${topic}`)}).catch((e) => {console.error(`Error unsubscribe from topic: ${e}`)});
break;
case false:
task = Messaging.unsubscribeFromTopic(topic).then(() => {console.log`Unsubscribed From Topic: ${topic}`}).catch((e) => {console.error(`Error unsubscribing from topic: ${e}`)});
}
return () => task;
}*/

useEffect(() => {
const notifications = user?.preferences?.notifications;
if (notifications) {
setPreferences(notifications);
}
else {
setPreferences(null);
}
},[user]);

//Gets Catalogs -- Adjust this to only get once and then manipulate data onward...
//Right now it is making a DB call each time you check the box...
useEffect(() => {
if (preferences) {
catalogsRef
.where('productLine', 'in', productLines)
.orderBy('z-index', 'asc')
.get()
.then((querySnapshot) => {
const allCatalogs = [];
querySnapshot.forEach((doc) => {
const catalog = {
title: doc.data().title,
description: doc.data().description,
image: doc.data().image,
expanded: false,
productLine: doc.data().productLine,
notifications: {
enabled: lookupPreference(doc.data().productLine)
}
}
catalog.id = doc.id;
allCatalogs.push(catalog);
});
setCatalogs(allCatalogs);
setLoading(false);
}).catch((err) => {
console.error('Error getting catalogs: ', err);
Crashlytics.recordError(err);
setLoading(false);
})
}
},[]);


useEffect(() => {
const allCatalogs = [];
catalogs.forEach((catalog) => {
catalog.notifications.enabled = lookupPreference(catalog.productLine);
allCatalogs.push(catalog);
});
setCatalogs(allCatalogs);
},[preferences]);


const renderPLItem = ({item, index}) => {
return (
<ListItem
    containerStyle={styles.listItem}
    bottomDivider={true}>
    <Image
     source={{ uri: item.image }}
     containerStyle={styles.image}
     PlaceholderContent={<Loader />}
     />
      <ListItem.Content>
        <ListItem.Title><Text style={styles.titleText}>{item.title}</Text></ListItem.Title>
        <View style={styles.subtitleView}>
          <Text style={styles.subtitleText}>{item.description}</Text>
        </View>
      </ListItem.Content>
      <Switch
      value={item.notifications.enabled}
      onValueChange={(value) => setPreference(item.productLine, value)}
      />
    </ListItem>
)
}


if (loading) {
return (
<Loader />
)
}

return (
<SafeAreaView>
{catalogs && (
<>
<View style={{backgroundColor: 'transparent', margin: 20}}>
<Text style={{color: 'black'}}>Set your preferred preferences for <Text style={{fontWeight: 'bold'}}>Push Notifications</Text>.{'\n'}Pricing Alerts and Product Updates will still appear in the <Text style={{color: 'black', textDecorationLine: 'underline', fontWeight: 'bold'}}onPress={() => {navigation.navigate('Activity Feed')}}>Activity Feed</Text>.</Text>
</View>
    <FlatList
     data={catalogs}
     renderItem={renderPLItem}
     //ListEmptyComponent={networkStatus.isConnected? emptyList : emptyListNoNetwork}
     keyExtractor={(item) => item.id}
     removeClippedSubviews={true}
     showsVerticalScrollIndicator={false}
     style={{marginBottom: "30%"}}
     />
  </>
)}
</SafeAreaView>
)
}